var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-stack",class:{'notification-stack--active': _vm.notifications.length}},_vm._l((_vm.notifications),function(notification){return _c('Notification',{key:notification.id,attrs:{"notification":notification},on:{"removed":_vm.handleRemoved}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }